import React, { useState } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button, CardContent, TextField } from "@mui/material";
import FormFieldLayout from "../components/layout/FormFieldLayout";
import FormControlsLayout from "../components/layout/FormControlsLayout";
import PageLayout from "../components/layout/PageLayout";
import {useTranslation} from "react-i18next";

const RecoveryPage = () => {
    const {t} = useTranslation();
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(null);
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        setMessage(null);
        setEmailError(null);
        const trimmedEmail = email?.trim() ?? "";
        if (!trimmedEmail) {
            setEmailError(t("auth.register.errors.emailRequired"));
            return;
        }
        setLoading(true);
        fetch('/api/RestoreRq', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: trimmedEmail }),
        })
            .then((response) => response.json())
            .then((body) => {
                setEmailError(null);
                if (body.status === 'OK') {
                    setMessage(t("auth.recovery.messages.sent"));
                    setIsError(false);
                } else if (body.status === 'TOO_OFTEN') {
                    setMessage(t("auth.recovery.messages.tooOften"));
                    setIsError(true);
                } else if (body.status === 'NOT_EXIST') {
                    setMessage(t("auth.recovery.messages.notExist"));
                    setIsError(false);
                } else {
                    setMessage(t("auth.recovery.messages.generic"));
                    setIsError(true);
                }
            })
            .catch((err) => {
                console.error('[RestoreRq] error', err);
                setEmailError(null);
                setMessage(t("auth.recovery.messages.generic"));
                setIsError(true);
            })
            .finally(() => setLoading(false));
    };

    return (
        <PageLayout
            title={t("auth.recovery.title")}
            showMenuButton={false}
            showNavigationMenu={false}
            cardStyle={{ marginLeft: 330, marginTop: 10, marginRight: 10, marginBottom: 10 }}
        >
            <CardContent>
                {message && (
                    <FormFieldLayout>
                        <Alert severity={isError ? "error" : "success"} onClose={() => setMessage(null)}>
                            {message}
                        </Alert>
                    </FormFieldLayout>
                )}
                <FormFieldLayout>
                    <TextField
                        required
                        label={t("auth.recovery.email")}
                        variant="standard"
                        sx={{ width: 300 }}
                        type="email"
                        value={email}
                        error={Boolean(emailError)}
                        helperText={emailError || undefined}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setMessage(null);
                            setEmailError(null);
                        }}
                        disabled={loading}
                    />
                </FormFieldLayout>
                <FormControlsLayout>
                    <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                        {loading ? t("auth.recovery.sending") : t("auth.recovery.sendRecoveryEmail")}
                    </Button>
                    <Button variant="outlined" component={RouterLink} to="/signin" disabled={loading}>
                        {t("auth.recovery.signIn")}
                    </Button>
                    <Button variant="outlined" component={RouterLink} to="/registration" disabled={loading}>
                        {t("auth.recovery.signUp")}
                    </Button>
                </FormControlsLayout>
            </CardContent>
        </PageLayout>
    );
};

export default RecoveryPage;